export const COLLECTION_FEE = 4500;
export const COLLECTION_SURCHARGE = 599;
export const REDELIVER_FEE = 695;
export const REDELIVER_SURCHARGE = 399;
export const SHIPPING_FEE = 2999;
export const FURNITURE_DISASSEMBLY_FEE = 7900;

/**
 * Where the removals service operates.
 *
 * Both legs of a removals booking validate against this — the address being
 * moved from and the one being moved to. It was written out twice in
 * `CollectionDelivery.tsx`, which meant adding a city to one leg and not the
 * other would let a customer book a collection we serve and a delivery we
 * refuse, only finding out at the second field.
 */
export const REMOVALS_SERVICE_CITIES = [
  'London',
  'Exeter',
  'Sheffield',
  'Cambridge',
  'Essex',
];
